import { React, useState } from "react";
import {
	AddproductWrapper,
	Title,
	AddButtonGroup,
	AddButton,
	// ChangeButton,
	MajorImportButton,
} from "../ProductsPage.styled";
import SingleOrderForm from "../Forms/SingleOrderForm";
import { getFormattedAmount } from "../../../utils/AmountUtils";


function SingleOrder() {
    const [productName, setProductName] = useState("");
	const [productPrice, setProductPrice] = useState("");
	const [ImagesUrl, setImagesUrl] = useState({
		firstImage: "",
		secondImage: "",
		thirdImage: ""
	});


    return (
		<AddproductWrapper>
			<Title>Order Information</Title>
			<main>
				<div className='LeftSection'>
					<div className='productDetails'>
						<MajorImportButton>
							<img className='' src={ImagesUrl.firstImage || "/images/placeholder_img.jpg"} />
						</MajorImportButton>
						<p className=''>{productName}</p>
						<p className='price'>
							{productPrice === "Price"
								? productPrice
								: getFormattedAmount.format(productPrice)}
						</p>
					</div>
					<AddButtonGroup>
						<AddButton>
							<img
								className=''
								style={{ width: "50px", height: "50px" }}
								src={ImagesUrl.firstImage || "/images/placeholder_img.jpg"}
								alt='import button'
							/>
						</AddButton>
						<AddButton>
							<img
								className=''
								style={{ width: "50px", height: "50px" }}
								src={ImagesUrl.secondImage || "/images/placeholder_img.jpg"}
								alt='import button'
							/>
						</AddButton>
						<AddButton>
							<img
								className=''
								style={{ width: "50px", height: "50px" }}
								src={ImagesUrl.thirdImage ||"/images/placeholder_img.jpg"}
								alt='import button'
							/>
						</AddButton>
					</AddButtonGroup>

					{/* <ChangeButton>
						<img
							className=''
							style={{ width: "25px", height: "25px" }}
							src={ImportIcon}
							alt='import button'
						/>
						<p>Change Image</p>
					</ChangeButton> */}
				</div>

				<div className='productForm'>
					<SingleOrderForm
						setProductName={setProductName}
						setProductPrice={setProductPrice}
						setImagesUrl={setImagesUrl}
					/>
				</div>
			</main>
		</AddproductWrapper>
	);
}

export default SingleOrder